/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteAdminCtrl',[ "$scope","$routeParams","$spMenu","$http","CookieFactory","WebPreLoaderData",
        function ( $scope,$routeParams,$spMenu,$http,CookieFactory,WebPreLoaderData) {
            //LOADING PARAMETER
            if ($routeParams.tokenAdmin)
            {
                var tokenAdmin = $routeParams.tokenAdmin;
                var currentUser = CookieFactory.getCookie('flexyBeauty-pro-user');//compare with pro token cookie to allow admin mode

                $scope.addHeadersForMangopay();
                if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin)
                {
                    $scope.ad.tokenAdmin = tokenAdmin;
                    $http.defaults.headers.common.Authorization = currentUser.token;  //use admin session for save
                }
                else
                {
                    currentUser = CookieFactory.getCookie('flexyBeauty-connect-user-'+WebPreLoaderData.companyCode);//compare with connect pro token cookie to allow admin mode
                    if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin)
                    {
                        $scope.ad.tokenAdmin = tokenAdmin;
                        $http.defaults.headers.common.Authorization = currentUser.token;  //use admin session for save
                    }
                    else
                    {
                        currentUser = CookieFactory.getCookie('flexyBeauty-group-user');//compare with group token cookie to allow admin mode

                        if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin)
                        {
                            $scope.ad.tokenAdmin = tokenAdmin;
                            $http.defaults.headers.common.Authorization = currentUser.token+"&"+ WebPreLoaderData.companyCode;  //use admin session for save
                        }
                        else
                        {
                            currentUser = CookieFactory.getCookie('flexyBeauty-admin-user');//compare with group admin cookie to allow admin mode

                            if (tokenAdmin && currentUser && currentUser.token && currentUser.token == tokenAdmin)
                            {
                                $scope.ad.tokenAdmin = tokenAdmin;
                                $http.defaults.headers.common.Authorization = currentUser.token+"&"+ WebPreLoaderData.companyCode;  //use admin session for save
                            }
                        }

                    }
                }

                $scope.loadAdminFunctions();


            }




        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteAdminCtrl.js